import { Box } from '@mui/material'
import Link from 'next/link'
// import { statsigLog } from '../../lib/statsigAndGa'
import HouseLogo from '@/components/icons/houseLogo'
import Facebook from '../icons/footer/facebook'
import Twitter from '../icons/footer/twitter'
import Instagram from '../icons/footer/instagram'
import Youtube from '../icons/footer/youtube'
import TikTok from '../icons/newHome/tikTok'

const CURRENT_YEAR = new Date().getFullYear()

const Footer = () => {
  const list = [
    {
      url: 'https://www.facebook.com/RentyAi',
      icon: <Facebook className="w-6 h-6" color="#B0B0B0" />,
      title: 'Renty Facebook'
    },
    {
      url: 'https://twitter.com/RentyAi',
      icon: <Twitter className="w-6 h-6" color="#B0B0B0" />,
      title: 'Renty Twitter'
    },
    {
      url: 'https://instagram.com/renty.ai?igshid=OGQ5ZDc2ODk2ZA==',
      icon: <Instagram className="w-6 h-6" color="#B0B0B0" />,
      title: 'Renty Instagram'
    },
    {
      url: 'https://www.youtube.com/channel/UCUFb-jAiIo8bsVgYHEfXpTQ',
      icon: <Youtube className="w-6 h-6" color="#B0B0B0" />,
      title: 'Renty Youtube'
    },
    {
      url: 'https://www.tiktok.com/@renty.ai',
      icon: <TikTok className="w-6 h-6" color="#B0B0B0" />,
      title: 'Renty Tiktok'
    }
  ]

  return (
    <Box component="footer" className="flex items-center bg-gray-200 px-7 py-10">
      <HouseLogo className=" mr-6" />
      <Box component="div" className="text-tertiary">
        <Box component="div" className="flex justify-end items-center gap-6 mb-3">
          {list.map(item => (
            <Link href={item.url} target="_blank" key={item.url} title={item.title}>
              {item.icon}
            </Link>
          ))}
        </Box>
        <Box component="div" className="text-xs whitespace-nowrap">
          © {CURRENT_YEAR} Renty.AI Inc. All Rights Reserved
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
